module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-11.1a620230.jpg";